import React from 'react';
import { NavigationRoute, useNavigation, useRouterPath } from 'shared-utils';
import { useYearlyRootNavigation } from 'utils/yearStore';
import Breadcrumb from 'components/Breadcrumb';
import { DashboardNavigation, InspectionNavigation } from 'screens/routes';

type Props = {
    label: string;
};

const InspectionDetailsBreadcrumb: React.FC<Props> = ({ label }: Props) => {
    const homePath = useRouterPath(DashboardNavigation());
    const [rootNavigations] = React.useState({ inspectionNav: InspectionNavigation });
    const { inspectionNav } = useYearlyRootNavigation(rootNavigations);
    const inspectionPath = useRouterPath(inspectionNav);
    const { push: navigate } = useNavigation();

    const triggerNav = React.useCallback((route: NavigationRoute) => (event: React.MouseEvent<any>) => {
        if (event.ctrlKey || event.metaKey) return;

        event.preventDefault();
        navigate(route);
    }, [navigate]);

    return (
        <Breadcrumb>
            <Breadcrumb.Home
                key="bc-home"
                to={homePath ?? undefined}
                onClick={triggerNav(DashboardNavigation())}
            />
            <Breadcrumb.Item
                key="bc-inspection"
                to={inspectionPath ?? undefined}
                onClick={triggerNav(inspectionNav)}
            >
                Visites
            </Breadcrumb.Item>
            <Breadcrumb.Item key="bc-inspection-details">{label}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default InspectionDetailsBreadcrumb;
